import { BaseService } from "./base.service";
import {
	IAccessRightModel,
	IAddUpdateRoleMenuAccessRight,
	IMenuAccessRightModel,
} from "models/MenuAccessRightModel";
import { IRole } from "models/RoleModel";

class RoleServiceInternal extends BaseService {
	getRoleList = async (): Promise<IRole[]> =>
		this.callApi<IRole[]>(`Role/GetRoleList`, "GET");

	getRoleMenuAccessRights = async (
		userRoleId: number
	): Promise<IMenuAccessRightModel[]> =>
		this.callApi<IMenuAccessRightModel[]>(
			`Role/GetRoleMenuAccessRights/${userRoleId}`,
			"GET"
		);

	getAccessRightsList = async (): Promise<IAccessRightModel[]> =>
		this.callApi<IAccessRightModel[]>(`AccessRight/GetAccessRightList`, "GET");

	addNewRole = async (roleName: string): Promise<number> =>
		this.callApi<number>(`Role/Save`, "POST", undefined, {
			name: roleName,
		});

	saveUpdateRoleMenuAccessRight = async (
		model: IAddUpdateRoleMenuAccessRight
	): Promise<undefined> =>
		this.callApi<undefined>(
			`Role/SaveUpdateRoleMenuAccessRight`,
			"POST",
			undefined,
			model
		);
}

export const RoleService = new RoleServiceInternal();
